import styled from "@emotion/styled";

const Card = styled.div`
  background-color: white;
  padding: 2em;
  box-shadow: 0px 0px 10px #35466933;
`;

export default Card;
